<template>
    <div class="calendar-head component">
      <template v-if="windowWidth > mobileWidth">
        <div v-for="(date, idx) in weekDisplay" :key="idx" class="calender-head-item" :class="{ disabled: !date.active, active: date.date === selectDate }" @click="onDateClick(date.date)">
          <div>
            <p class="day-of-week">{{ dayOfWeek(date.date) }}</p>
            <p class="date">{{ dateDisplay(date.date) }}</p>
          </div>
        </div>
        <button class="previous" v-if="weekIndex>0" @click="weekIndexChange('reduction')"><i class="chevron chevron-left"></i></button>
        <button class="next" @click="weekIndexChange('add')"><i class="chevron chevron-right"></i></button>
      </template>
      <template v-else>
        <swiper ref="mySwiper" class="swiper" :options="swiperOption">
          <swiper-slide v-for="(date, idx) in monthDisplay" :key="idx">
            <div class="calender-head-item" :class="{ disabled: !date.active, active: date.date === selectDate }" @click="onDateClick(date.date)">
              <div>
                <p class="day-of-week">
                  {{ dayOfWeek(date.date) }}
                </p>
                <p class="date">
                  {{ dateDisplay(date.date) }}
                </p>
              </div>
            </div>
          </swiper-slide>
          <div slot="scrollbar" class="swiper-scrollbar" />
        </swiper>
      </template>
    </div>
  </template>
  
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import moment from 'moment'
export default {
  name: 'CalendarHead',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    windowWidth: { type: Number, default: 0 },
    parentDateClickHandler: { type: Function, default: () => {} }
  },
  
  data () {
    return {
      weekIndex: 0,
      date: '',
      selectDate: '',
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        observer: true,
        observeParents: true,
        on: {
          reachEnd: () => {
            this.loadMoreDates()
          }
        }
      },
      monthDisplay: []
    }
  },
  watch: {
    weekIndex: function (val) {
      this.calSelectDate()
    }
  },
  computed: {
    today () {
      return moment().format('YYYY-MM-DD')
    },
    weekDisplay () {
      const from_date = moment(this.date || this.today).utc().zone(-9).add(7 * this.weekIndex, 'days')
      const week = []
      for (let i = 0; i < 7; i++) {
        week.push({
          date: from_date.format('YYYY-MM-DD'),
          active: true
        })
        from_date.add(1, 'days')
      }
      return week
    },
    // monthDisplay () {
    //   const from_date = moment(this.date || this.today).utc().zone(-9)
    //   const month = []
    //   for (let i = 0; i < 31; i++) {
    //     month.push({
    //       date: from_date.format('YYYY-MM-DD'),
    //       active: true
    //     })
    //     from_date.add(1, 'days')
    //   }
    //   return month
    // },
    mobileWidth () {
      return this.$store.state.dom.widthSmall
    }
  },
  methods: {
    dayOfWeek (dateStr) {
      const _dayOfWeek = moment(dateStr).utc().zone(-9).format('dddd').toLowerCase()
      return this.$i18n.messages[this.$i18n.fallbackLocale].dayOfWeek[_dayOfWeek]
    },
    dateDisplay (dateStr) {
      return moment(dateStr).utc().zone(-9).format('MM/DD')
    },
    weekIndexChange (type = 'add') {
      let newWeekIndex = this.weekIndex
  
      if (type === 'add') {
        newWeekIndex++
      } else {
        newWeekIndex--
      }
  
      this.weekIndex = newWeekIndex
    },
    calSelectDate () {
      const curDay = this.weekDisplay[0].date
  
      this.onDateClick(curDay)
      this.selectDate = curDay
    },
    onDateClick (dateStr) {
      if (dateStr !== this.selectDate) {
        this.selectDate = dateStr
        this.$emit('onDateClick')
        this.parentDateClickHandler(this.selectDate)
      }
    },
    // 初始化日历数据
    initMonthDisplay () {
      const today = moment(this.date || this.today).utc().zone(-9) // 使用 Tokyo 时区
      this.monthDisplay = this.generateDates(today, 14) // 初始加载 31 天
    },
    // 生成一段日期数据
    generateDates (startDate, count) {
      const dates = []
      for (let i = 0; i < count; i++) {
        dates.push({
          date: startDate.clone().format('YYYY-MM-DD'),
          active: true
        })
        startDate.add(1, 'days')
      }
      return dates
    },
    loadMoreDates (type) {
      const lastDate = this.monthDisplay[this.monthDisplay.length - 1].date
      const newDays = []
      
      const from_date = moment(lastDate).add(1, 'days')

      for (let i = 0; i < 7; i++) {
        newDays.push({
          date: from_date.format('YYYY-MM-DD'),
          active: true
        })
        from_date.add(1, 'days')
      }

      // **添加 7 天数据，并删除最前面的 7 天**
      this.monthDisplay = [...this.monthDisplay, ...newDays]
    }
  },
  mounted () {
  },
  created () {
    if (this.$route.query && this.$route.query.date && moment(this.$route.query.date).isValid()) {
      this.date = this.$route.query.date
    }
    this.calSelectDate()
    this.initMonthDisplay()
  }
}
</script>
<style lang="scss" scoped>
  .calendar-head {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    padding: 0 50px;
    .swiper-container {
      width: 100%;
    }
    .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 25%;  /* 自动调整宽度 */
      flex-shrink: 0;  /* 防止 slide 变小 */
    }

      .swiper-scrollbar {
        background: var(--Background-color);
      }

      .calender-head-item {
        min-width: 80px; /* 设定一个最小宽度 */
        width: calc(100% / 7);
        padding: 8px;
        text-align: center;
        transform: skewX(-15deg);

        &:hover {
          cursor: pointer;
        }

        > * {
          transform: skewX(15deg);
        }

        .day-of-week {
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.72px;

          @include media_mobile {
            font-size: 14px;
            letter-spacing: 0.54px;
          }
        }

        .date {
          font-size: 20px;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.9px;

          @include media_mobile {
            font-size: 16px;
            letter-spacing: 0.63px;
          }
        }

        p + p {
          margin-top: 10px;

          @include media_mobile {
            margin-top: 0;
          }
        }

        &.disabled {
          pointer-events: none;

          p {
            color: var(--Secondary-font-color);
          }
        }

        &.active {
          background-color: var(--Main-color);

          p {
            color: $color-white-1;
          }
        }

        @include media_mobile {
          width: 80%;
          margin: auto;
        }
      }

      button {
        position: absolute;
        width: 26px;
        height: 26px;
        border: 0 solid;
        border-radius: 26px;
        background-color: $color-grey-7;

        &:hover {
          cursor: pointer;
        }

        &.previous {
          left: 15px;
        }

        &.next {
          right: 15px;
        }

        .chevron {
          border-right: 1px solid $color-black-1;
          border-bottom: 1px solid $color-black-1;
        }
      }

      @include media_mobile {
        flex-wrap: wrap;
        justify-content: center;
        padding: 0 17px;
      }
  }
</style>
